import * as React from 'react';
import {Query} from 'react-apollo';
import {DragDropContext} from 'react-beautiful-dnd';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SalesAutomationStage as SalesAutomationStageFragment,
    DripSequenceStartTriggersForStageset as DripSequenceStartTriggersForStagesetQuery,
    DripSequenceStartTriggersForStagesetVariables as DripSequenceStartTriggersForStagesetQueryVariables,
    DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers as StartTrigger,
} from 'nutshell-graphql-types';

import {CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS} from '../../constants';
import GET_DRIP_SEQUENCE_START_TRIGGERS_FOR_STAGESET from '../../graphql/queries/get-drip-sequence-start-triggers-for-stageset.graphql';

import {StageCardsStartTriggers} from '../card-containers/stage-cards-start-triggers';

import {CollapsibleSection} from './collapsible-section';
import {translateDripSequenceStartTriggersData} from './translate-drip-sequences-start-triggers-data';

type Props = OwnProps & {
    isLoadingEmailAutomations: boolean;
    startTriggers: {
        [key: string]: StartTrigger | null | undefined[];
    };
    // @ts-expect-error
    errorMessage: string | React.ReactElement<React.ComponentProps<string>> | null | undefined;
};

type State = {
    isCardBeingDragged: boolean;
};

/*
 * Top-level component responsible for rendering the entire "emails"
 * section (row) on the sales automation setup board.
 */
export class SalesAutomationDripSequenceTriggersComponent extends React.PureComponent<
    Props,
    State
> {
    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            isCardBeingDragged: false,
        };
    }

    render() {
        return (
            <DragDropContext
                onDragStart={() => this.setState({isCardBeingDragged: true})}
                onDragEnd={this.handleItemMoved}
            >
                <CollapsibleSection type={CLOSED_LEAD_DRIP_SEQUENCE_START_TRIGGERS}>
                    {this.props.stages.map((stage, index) => {
                        const startTriggersForStage = this.props.startTriggers[stage.id];

                        return (
                            <StageCardsStartTriggers
                                key={stage.id}
                                parentId={stage.id}
                                errorMessage={this.props.errorMessage}
                                isLoading={this.props.isLoadingEmailAutomations}
                                hideCards={this.props.hideCards}
                                // @ts-expect-error
                                startTriggers={startTriggersForStage}
                                isCardBeingDragged={this.state.isCardBeingDragged}
                                numberOfStagesSpanned={this.props.stages.length - index}
                                isFirstStage={index === 0}
                            />
                        );
                    })}
                </CollapsibleSection>
            </DragDropContext>
        );
    }

    handleItemMoved = () => {
        this.setState({isCardBeingDragged: false});
    };
}

type OwnProps = {
    stages: SalesAutomationStageFragment[];
    hideCards: boolean;
};
type RoutedProps = OwnProps & ContextRouter;

class StagesetQuery extends Query<
    DripSequenceStartTriggersForStagesetQuery,
    DripSequenceStartTriggersForStagesetQueryVariables
> {}

const Stageset = (props: RoutedProps) => {
    const {stagesetId} = props.match.params;
    if (!stagesetId) return null;

    return (
        <StagesetQuery
            query={GET_DRIP_SEQUENCE_START_TRIGGERS_FOR_STAGESET}
            // We need to ensure this doesn't get cached, because it will be
            // overwritten by the drip sequnece query when the sidebar is
            // opened.
            fetchPolicy='no-cache'
            variables={{stagesetId}}
        >
            {({data, loading, error}) => {
                const stageset = data ? data.stageset : null;

                // @ts-expect-error
                const stageIds = props.stages.map((stage) => stage.id);

                const startTriggers = translateDripSequenceStartTriggersData(stageIds, stageset);

                // @ts-expect-error
                const errorMessage = safelyGetGraphQLErrorMessage(error);

                return (
                    <SalesAutomationDripSequenceTriggersComponent
                        stages={props.stages}
                        hideCards={props.hideCards}
                        isLoadingEmailAutomations={loading}
                        startTriggers={startTriggers}
                        errorMessage={errorMessage}
                    />
                );
            }}
        </StagesetQuery>
    );
};

// @ts-expect-error
export const SalesAutomationDripSequenceTriggers = withRouter<OwnProps>(Stageset);
